export const sizes: any = {
	xs: 3,
	s: 6,
	m: 12,
	l: 24
};

export const transferTypes: any = {
	es: [
		{
			label: 'Venta',
			value: 'Venta'
		},
		{
			label: 'Fallecimiento',
			value: 'Fallecimiento'
		}
	],
	en: [
		{
			label: 'Sale',
			value: 'Sale'
		},
		{
			label: 'Death',
			value: 'Death'
		}
	]
};

export const sectorOptionsLanguages = [
	{ es: 'Construcción', en: 'Construction' },
	{ es: 'Comercio Internacional', en: 'International trade' },
	{ es: 'Deportista profesional', en: 'Professional athlete' },
	{ es: 'Anticuario', en: 'Antique dealer' },
	{ es: 'Comercio de metales preciosos', en: 'Precious metal trade' },
	{ es: 'Organismos sin ánimo de lucro', en: 'Non-profit organizations' },
	{ es: 'Compra-venta moneda extranjera', en: 'Foreign currency trading' },
	{ es: 'Empresa de Auditoría', en: 'Audit firm' },
	{ es: 'Administraciones Públicas', en: 'Public Administrations' },
	{ es: 'Industria tabaquera', en: 'Tobacco Industry' },
	{ es: 'Automóviles', en: 'Automobiles' },
	{ es: 'Joyería', en: 'Jewelry' },
	{ es: 'Venta al por mayor', en: 'Wholesale' },
	{ es: 'Gestión y alquiler de bienes inmuebles', en: 'Real Estate Management and Rental' },
	{ es: 'Comercio electrónico', en: 'E-commerce' },	
	{ es: 'Intermediarios financieros', en: 'Financial Intermediaries' },
	{ es: 'Comercio de arte', en: 'Art Trading' },
	{ es: 'Casinos', en: 'Casinos' },
	{ es: 'Despacho de Abogado', en: 'Law Firm' },
	{ es: 'Notaría', en: 'Notary\'s office' }
]

export const physicalSourceOptionsLanguages = [
	{ es: 'Salario', en: 'Salary' },
	{ es: 'Actividad empresarial', en: 'Business activity' },
	{ es: 'Venta de bienes', en: 'Sale of goods' },
	{ es: 'Indemnización', en: 'Compensation' },
	{ es: 'Donación', en: 'Donation' },
	{ es: 'Herencia', en: 'Inheritance' },
	{ es: 'Inversiones financieras', en: 'Financial investments' },
];

export const legalSourceOptionsLanguages = [
	{ es: 'Actividad empresarial', en: 'Business activity' },
	{ es: 'Rentas inmobiliarias', en: 'Real estate income' },
	{ es: 'Rentas financieras', en: 'Financial income' },
];

export const amountOptionsLanguages = [
	{ es: 'Sin ingresos', en: 'Without incomes' },
	{ es: 'Hasta 30.000 euros', en: 'Up to 30,000 euros' },
	{ es: 'De 30.000 a 60.000 euros', en: 'From 30,000 to 60,000 euros' },
	{ es: 'De 60.000 a 100.000 euros', en: 'From 60,000 to 100,000 euros' },
	{ es: 'De 100.000 a 300.000 euros', en: 'From 100,000 to 300,000 euros' },
	{ es: 'Más de 300.000', en: 'More than 300,000' }
];

export const employmentOptionsLanguages = [
	{ es: 'Cuenta propia', en: 'Self-employed' },
	{ es: 'Cuenta ajena', en: 'Employee' },
	{ es: 'Jubilado', en: 'Retired' },
	{ es: 'Desempleado', en: 'Unemployed' },
	{ es: 'Pensionista', en: 'Pensioner' },
	{ es: 'Estudiante', en: 'Student' },
	{ es: 'Sin ocupación', en: 'Without occupation' }
];

export const jobTitleOptionsLanguages = [
	{ es: 'Director / socio', en: 'Director / Partner' },
	{ es: 'Técnico Senior', en: 'Senior Technician' },
	{ es: 'Técnico', en: 'Technician' },
	{ es: 'Administrativo', en: 'Administrative' },
	{ es: 'No aplicable', en: 'Not applicable' }
];

export const FileTypes: { [key: string]: string } = {
	// Document type keys (camelCase)
  	articlesOfIncorporation: 'Articles of Incorporation',
	statutesOrRegulations: 'Statutes or Regulations',
	statutesModification: 'Statutes Modification',
	representativesDocumentFile: 'Representatives Document File',
	regulatedEntityRegistry: 'Regulated Entity Registry',
	taxIdentificationCard: 'Tax Identification Card',
	beneficialOwnershipCertificate: 'Beneficial Ownership Certificate',
	representativePowerOfAttorney: 'Representative Power of Attorney',
	bankCertificate: 'Bank Certificate',
	taxDomicileCertificate: 'Tax Domicile Certificate',
	w8BEN: 'W-8BEN',
	w9: 'W-9',
	tin: 'TIN',
	taxResidenceCertificate: 'Tax Residence Certificate',
	// Identity documents (lowercase keys and translations)
	dni: 'DNI',
	nif: 'NIF',
	passport: 'Passport',
	residenceCard: 'Residence Card',
	'DNI': 'DNI',
	'NIF': 'NIF',
	'Passport': 'Passport',
	'Residence Card': 'Residence Card',
	// Funds origin for Physical Persons - Spanish
	'Salario': 'Salary',
	'Venta de bienes': 'Sale of goods',
	'Indemnización': 'Compensation',
	'Donación': 'Donation',
	'Herencia': 'Inheritance',
	'Inversiones financieras': 'Financial investments',
	// Funds origin for Physical Persons - English
	'Salary': 'Salary',
	'Sale of goods': 'Sale of goods',
	'Compensation': 'Compensation',
	'Donation': 'Donation',
	'Inheritance': 'Inheritance',
	'Financial investments': 'Financial investments',
	// Funds origin for Physical Persons - Portuguese
	'Salário': 'Salary',
	'Atividade empresarial': 'Business activity',
	'Venda de bens': 'Sale of goods',
	'Indenização': 'Compensation',
	'Doação': 'Donation',
	'Herança': 'Inheritance',
	'Investimentos financeiros': 'Financial investments',
	// Funds origin for Legal Entities - Spanish
	'Actividad empresarial': 'Business activity',
	'Rentas inmobiliarias': 'Real estate income',
	'Rentas financieras': 'Financial income',
	// Funds origin for Legal/Physical Entities - English
	'Business activity': 'Business activity',
	'Real estate income': 'Real estate income',
	'Financial income': 'Financial income',
	// Funds origin for Legal Entities - Portuguese
	'Rendimentos imobiliários': 'Real estate income',
	'Rendimentos financeiros': 'Financial income'
};

export const administratorOptionsLanguages = [
	{ es: 'Representante', en: 'Representative' },
	{ es: 'Apoderado', en: 'Attorney' }
];

export const administratorTypeOptionsLanguages = [
	{ es: 'Único', en: 'Sole' },
	{ es: 'Solidario', en: 'Solidary' },
	{ es: 'Mancomunado', en: 'Joint' }
];
